import React from "react";
import { motion } from "framer-motion";
import { FileUp, ClipboardCheck, Users, Receipt, BadgeCheck } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { IMG } from "../lib/data";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";

const ICONS = [FileUp, ClipboardCheck, Users, Receipt, BadgeCheck];

const HowItWorksPage = () => {
  const { t } = useLanguage();
  const p = t.howItWorksPage;

  return (
    <div data-testid="how-it-works-page">
      <PageHero label={p.label} title={p.heading} sub={p.sub} image={IMG.engineer} />

      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="space-y-6">
            {p.steps.map((s, i) => {
              const I = ICONS[i] || BadgeCheck;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="group flex items-start gap-6 bg-[#11203A] border border-white/12 p-7 md:p-8 hover:border-[#D4AF37]/40 transition-colors duration-300"
                  data-testid={`hiw-step-${i + 1}`}
                >
                  <div className="shrink-0 flex flex-col items-center gap-3">
                    <span className="w-14 h-14 grid place-items-center border border-[#D4AF37]/30 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-[#0A1223] transition-colors duration-300">
                      <I size={24} />
                    </span>
                    <span className="font-heading text-sm font-extrabold text-[#D4AF37]">0{i + 1}</span>
                  </div>
                  <div>
                    <h3 className="font-heading text-xl font-bold text-white leading-snug">{s.title}</h3>
                    <p className="mt-3 text-sm text-slate-300 leading-relaxed">{s.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default HowItWorksPage;
